import { combineReducers } from 'redux';
import { AUTH_MODULE_KEY, authReducer } from './modules/Auth';
import { ENTITIES_MODULE_KEY, entitiesReducer } from './modules/entities';
import { CLIENT_MODULE_KEY, clientReducer } from './Client/reducer';
import { ORGANIZATION_MODULE_KEY, organizationReducer } from './Organization';
import { CSV_IMPORT_MODULE_KEY, csvImportReducer } from './CsvImport';
import { PARTICIPANT_MODULE_KEY, participantReducer } from './Participant';
import { paramsReducer, PARAMS_MODULE_KEY } from './Params';

export const rootReducer = combineReducers({
  [AUTH_MODULE_KEY]: authReducer,
  [ENTITIES_MODULE_KEY]: entitiesReducer,
  [CLIENT_MODULE_KEY]: clientReducer,
  [ORGANIZATION_MODULE_KEY]: organizationReducer,
  [CSV_IMPORT_MODULE_KEY]: csvImportReducer,
  [PARTICIPANT_MODULE_KEY]: participantReducer,
  [PARAMS_MODULE_KEY]: paramsReducer,
});
